export const UPDATE_NOTES_LOADER = 'UPDATE_NOTES_LOADER'
export const UPDATE_NOTES_DATA = 'UPDATE_NOTES_DATA'
